// extracted by mini-css-extract-plugin
export default {"tabList":"HistoryTabs_tabList__5hVE+","tabTitle":"HistoryTabs_tabTitle__XQTHG","tabActive":"HistoryTabs_tabActive__l6QMt"};